module.exports = __webpack_public_path__ + "img/dango05.4faba1ef.png";